// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USERBETRIEB_SUCCESS = 'FETCH_USERBETRIEB_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_LOGOUT = 'DELETE_LOGOUT'

// betrieb.js

// saved.js

export const ISLISTINGSAVED = 'IS_LISTING_SAVED'

// landings.js

export const SET_HEIMATSTADT_SUCCESS = 'SET_HEIMATSTADT_SUCCESS'

// FETCH_BETRIEB_SUCCESS

// Zettel
// export const

// NACHRICHTEN
export const FETCH_NACHRICHTEN_SUCCESS = 'FETCH_NACHRICHTEN_SUCCESS'
export const FETCH_NACHRICHTEN_FAILURE = 'FETCH_NACHRICHTEN_FAILURE'

// export const UPDATE_BETRIEB = 'UPDATE_BETRIEB'
export const FETCH_BETRIEBE_SUCCESS = 'FETCH_BETRIEBE_SUCCESS'
export const FETCH_BETRIEBE_CLEAR = 'FETCH_BETRIEBE_CLEAR'
export const FETCH_BETRIEBE_SUCCESS_STANDORT = 'FETCH_BETRIEBE_SUCCESS_STANDORT'
export const FETCH_BETRIEBE_SUCHBEGRIFF = 'FETCH_BETRIEBE_SUCHBEGRIFF'
export const FETCH_BETRIEBE_SUCCESS_SET_LEISTUNG = 'FETCH_BETRIEBE_SUCCESS_SET_LEISTUNG'
export const FETCH_BETRIEBE_SUCCESS_SET_INNUNGEN = 'FETCH_BETRIEBE_SUCCESS_SET_INNUNGEN'

export const SET_BETRIEBE_SUCHBEGRIFF = 'SET_BETRIEBE_SUCHBEGRIFF'
export const SET_BETRIEBE_SUCHBEGRIFFMANUELL = 'SET_BETRIEBE_SUCHBEGRIFFMANUELL'
export const SET_BETRIEBE_STANDORT = 'SET_BETRIEBE_STANDORT'
export const SET_BETRIEBE_PLZ = 'SET_BETRIEBE_PLZ'
export const SET_BETRIEBE_RADIUS = 'SET_BETRIEBE_RADIUS'
export const SET_BETRIEBE_KH = 'SET_BETRIEBE_KH'

export const SET_LEISTUNGEN = 'SET_LEISTUNGEN'
export const SET_STAEDTE = 'SET_STAEDTE'

export const DELETE_BETRIEBE = 'DELETE_BETRIEBE'

export const NEUER_MARKER_SUCCESS = 'NEUER_MARKER_SUCCESS'
export const NEUER_GEOLOCATE_SUCCESS = 'NEUER_GEOLOCATE_SUCCESS'
export const NEUER_GEOLOCATE_DURCH_STADTWAHL_SUCCESS = 'NEUER_GEOLOCATE_DURCH_STADTWAHL_SUCCESS'
export const GEOLOCATE_RESET = 'GEOLOCATE_RESET'

export const FETCH_BETRIEBE_FAILURE = 'FETCH_BETRIEBE_FAILURE'

export const FETCH_GEOIP_SUCCESS = 'FETCH_GEOIP_SUCCESS'
export const FETCH_GEOIP_FAILURE = 'FETCH_GEOIP_FAILURE'

// feedback.js
export const RESPONSE_MSG = 'RESPONSE_MSG'
export const CLEAR_MSG = 'CLEAR_MSG'
